import { render, staticRenderFns } from "./MatrixActionsTableColumn.vue?vue&type=template&id=03321151"
import script from "./MatrixActionsTableColumn.vue?vue&type=script&lang=js"
export * from "./MatrixActionsTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports